import React from 'react';

function PrivacyPolicy() {
  return (
    <div style={{ maxWidth: '800px', margin: '40px auto', padding: '20px', lineHeight: '1.8', direction: 'rtl', textAlign: 'right' }}>
      <div style={{ backgroundColor: 'white', borderRadius: '15px', padding: '40px', boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)' }}>
        <h1 style={{ fontSize: '2rem', marginBottom: '1.5rem', color: '#333' }}>מדיניות פרטיות</h1>
        
        <h2 style={{ fontSize: '1.3rem', marginTop: '2rem', marginBottom: '1rem', color: '#333' }}>איסוף מידע</h2>
        <p style={{ color: '#555', fontSize: '1rem' }}>
          <strong>אנו לא אוספים כל מידע אישי</strong>. כל החישובים מתבצעים בדפדפן שלך בלבד וללא שליחת נתונים לשרתים.
        </p>

        <h2 style={{ fontSize: '1.3rem', marginTop: '2rem', marginBottom: '1rem', color: '#333' }}>עוגיות וניתוח</h2>
        <p style={{ color: '#555', fontSize: '1rem' }}>
          האתר <strong>לא משתמש בעוגיות</strong>. אנו עשויים להשתמש בשירות ניתוח (Cloudflare Web Analytics) שאינו אוסף מידע אישי ואינו משתמש בעוגיות או זיהוי משתמשים.
        </p>

        <h2 style={{ fontSize: '1.3rem', marginTop: '2rem', marginBottom: '1rem', color: '#333' }}>אבטחה</h2>
        <p style={{ color: '#555', fontSize: '1rem' }}>
          כל הנתונים נשארים בדפדפן שלך בלבד. איננו שומרים כל דבר בשרתים.
        </p>

        <div style={{ marginTop: '30px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px', textAlign: 'center' }}>
          <button 
            onClick={() => window.location.hash = ''} 
            style={{
              padding: '12px 30px',
              backgroundColor: '#667eea',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: 'bold',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#5568d3'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#667eea'}
          >
            חזור למחשבון
          </button>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
